import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/link.svg'
import _imports_1 from '../assets/copy.svg'


const _hoisted_1 = {
  key: 0,
  src: _imports_0
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1
}

export type ButtonProps = {
  data: {
    button: string;
    status: number;
  }; // 0:背景青ボタン 1: リンクアイコンありボタン 2: greyボタン 3: 背景白 青文字 4: コピーアイコンありボタン 5: 背景白 grey文字
};

export default /*@__PURE__*/_defineComponent({
  __name: 'CommonButton',
  props: {
    data: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      _ctx.data.status == 0
        ? 'active'
        : _ctx.data.status == 1
        ? 'link'
        : _ctx.data.status == 2
        ? 'inactive'
        : _ctx.data.status == 3
        ? 'back'
        : _ctx.data.status == 3
        ? 'copy'
        : 'font-grey',
    ])
  }, [
    _createElementVNode("span", null, _toDisplayString(_ctx.data.button), 1 /* TEXT */),
    (_ctx.data.status == 1)
      ? (_openBlock(), _createElementBlock("img", _hoisted_1))
      : _createCommentVNode("v-if", true),
    (_ctx.data.status == 4)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})